import { Button, Drawer, Label } from "@components";
import styles from "@styles/pages/flow/Flow.module.scss";
import { Currency } from "@utils/Currency";
import { useState } from "react";
import { FlowExecutionReportDrawer } from "./FlowExecutionReportDrawer";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

const labels = {
  sms: "SMS",
  email: "Email",
  push: "Push",
  whatsapp: "Whatsapp",
};

export const FlowReportDrawer = ({
  flowId,
  stepId,
  visible,
  reports,
  globalReport,
  onClose,
}) => {
  const [showExportDrawer, setShowExportDrawer] = useState(false);

  const groupCreatives = reports?.creatives?.reduce((acc, curr) => {
    const type = curr?.type;

    if (!acc[type]) {
      acc[type] = {
        type: type,
        opens: 0,
        conversionQuantity: 0,
        conversionTotal: 0,
        sent: 0,
        clicks: 0,
      };
    }

    acc[type].opens += curr.opens;
    acc[type].conversionQuantity += curr.conversionQuantity;
    acc[type].conversionTotal += curr.conversionTotal;
    acc[type].sent += curr.sent;
    acc[type].clicks += curr.clicks;

    return acc;
  }, {});

  const creatives = Object.values(groupCreatives || {}).sort((a) =>
    a.type.toLowerCase() === "email" ? -1 : 1
  );

  return (
    <Drawer
      visible={visible}
      closeInX
      closeInFade
      showCloseButton
      title="Relatórios"
      onClose={onClose}
      footer={
        <Button
          text="Outros relatórios"
          design="primary"
          className="w-100"
          onClick={() => setShowExportDrawer(true)}
        />
      }
    >
      <div className={styles.scrollContainer}>
        {!!reports && (
          <>
            <div className={styles.gridReport}>
              <div className={styles.item}>
                <p className={styles.value}>
                  {Currency.formatCurrency(+(reports?.conversionTotal || 0))}
                </p>
                <span className={styles.name}>Valor em vendas</span>
              </div>
              <div className={styles.item}>
                <p className={styles.value}>
                  {Currency.formatCurrency(+(reports?.conversionAverage || 0))}
                </p>
                <span className={styles.name}>Ticket médio</span>
              </div>
              {/* <div className={styles.item}>
                            <p className={styles.value}>
                                {Currency.formatCurrency(+(reports?.conversionCost || 0))}
                            </p>
                            <span className={styles.name}>Custo por conversão</span>
                        </div> */}
              {/* <div className={styles.item}>
                            <p className={styles.value}>
                                {reports?.grossIncome}x{" "}
                                <i className="far fa-arrow-trend-up" />
                            </p>
                            <span className={styles.name}>Retorno bruto</span>
                        </div> */}
            </div>
            {creatives.length > 0 &&
              creatives.map((r) => {
                return (
                  <>
                    <Label className="mt-20">
                      {labels[r?.type?.toLowerCase()]}
                    </Label>
                    <div
                      className={css({
                        totalizers: true,
                        email: r?.type?.toLowerCase() === "email",
                      })}
                    >
                      <div className={styles.totalizer} data-tooltip="Disparos">
                        <div className={styles.icon}>
                          <i className="fal fa-paper-plane-top" />
                        </div>
                        <span className={styles.value}>{+(r?.sent || 0)}</span>
                      </div>
                      {r?.type?.toLowerCase() === "email" && (
                        <div
                          className={styles.totalizer}
                          data-tooltip="Aberturas"
                        >
                          <div className={styles.icon}>
                            <i className="fal fa-check-double" />
                          </div>
                          <span className={styles.value}>
                            {+(reports?.opens || 0)}
                          </span>
                        </div>
                      )}
                      <div className={styles.totalizer} data-tooltip="Cliques">
                        <div className={styles.icon}>
                          <i className="fal fa-arrow-pointer" />
                        </div>
                        <span className={styles.value}>
                          {+(r?.clicks || 0)}
                        </span>
                      </div>
                      <div className={styles.totalizer} data-tooltip="Usos">
                        <div className={styles.icon}>
                          <i className="fal fa-sack-dollar" />
                        </div>
                        <span className={styles.value}>
                          {+(r?.conversionQuantity || 0)}
                        </span>
                      </div>
                    </div>
                  </>
                );
              })}
          </>
        )}
      </div>
      <FlowExecutionReportDrawer
        flowId={flowId}
        stepId={stepId}
        globalReport={globalReport}
        visible={showExportDrawer}
        onClose={() => setShowExportDrawer(false)}
      />
    </Drawer>
  );
};
